module.exports = __webpack_public_path__ + "img/retail-1.6df0af96.png";